<template>
  <div class="footer" v-if="authLoaded" :class="{ 'is-standalone': isStandalone }">
    <div class="footer-links" :class="{ 'footer-links-logged-in': user }">
      <template v-if="!user">
        <span class="footer-link" @click="$emit('open-login')">log in</span>
        <img src="/playground_assets/danseuse-white.png" alt="separator" class="footer-separator-icon small" />
        <span class="footer-link" @click="$emit('open-signup')">sign up</span>
        <img src="/playground_assets/danseuse-white.png" alt="separator" class="footer-separator-icon small" />
        <span class="footer-link" @click="toggleAbout">about</span>
      </template>
      <template v-else>
        <span class="footer-link" @click="$emit('open-profile')">profile</span>
        <img src="/playground_assets/danseuse-white.png" alt="separator" class="footer-separator-icon large" />
        <span class="footer-link" @click="toggleAbout">about</span>
      </template>
    </div>
  </div>
</template>

<script>
import AppEvent from "./event.vue";
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

export default {
  name: "AppFooter",
  components: {
    AppEvent
  },
  props: {
    button1: {
      type: String,
      default: "log in",
    },
    logo_path: {
      type: String,
      default: '/playground_assets/logo.png',
    },
    showAbout: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      user: null,
      authLoaded: false,
      isStandalone: false
    }
  },
  created() {
    onAuthStateChanged(auth, user => {
      this.user = user;
      this.authLoaded = true;
    });
    
    // Detect if running as home screen app (standalone mode)
    // iOS: navigator.standalone is true when added to home screen
    // Modern: matchMedia('(display-mode: standalone)')
    if (window.navigator.standalone === true) {
      this.isStandalone = true;
    } else if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
      this.isStandalone = true;
    }
  },
  methods: {
    toggleAbout () {
      if (!this.showAbout) {
        this.$emit("open-about");
      } else {
        this.$emit("close-about")
      }
    }
  }
};
</script>

<style scoped>
.footer {
  display: none;
}
.about {
  font-family: Syne;
  text-decoration: underline;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  color:#fff;
  padding-top: 20px;
}
.footer-links {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  flex-direction: row;
}
.footer-link {
  font-family: Syne;
  font-size: 0.9rem;
  cursor: pointer;
  text-decoration: underline;
  color: #fff;
}
.footer-separator {
  font-family: Syne;
  font-size: .75rem;
  color: #fff;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
}

.footer-separator-icon {
  filter: brightness(0) invert(1);
  margin-left: 0.3rem;
  margin-right: 0.3rem;
}

.footer-separator-icon.small {
  width: 16px;
  height: 16px;
}

.footer-separator-icon.large {
  width: 24px;
  height: 24px;
}
.container {
  margin-top: 1.5rem;
  flex-direction: row;
}
.invert {
  filter: invert(100);
}
@media(max-width: 768px) {
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    z-index: 10000;
    align-items: center;
    /* Default padding for non-iPhone devices (smaller, no black border) */
    padding: 0.8rem 1.3rem 1.0rem;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(10px);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    position: fixed;
    overflow: visible;
  }

  /* Default: no black border, text centered */
  .footer-links {
    margin-top: 0;
    gap: 0.5rem;
    /* Horizontal nudge only, no vertical shift needed when border doesn't exist */
    transform: translateX(6px);
  }

  /* When logged in (profile/about): shift left a bit */
  .footer-links.footer-links-logged-in {
    transform: translateX(-0px);
  }

  /* iPhone with home indicator AND running as home screen app: show black border and adjust padding */
  @supports (-webkit-touch-callout: none) {
    @supports (padding-bottom: env(safe-area-inset-bottom)) {
      /* Only show black border when running as standalone (home screen app) */
      .footer.is-standalone {
        /* More bottom padding so the text sits clearly above the solid base bar */
        padding: 0.8rem 1.3rem 2.8rem;
      }

      /* Solid black rectangle at the very bottom - only visible in standalone mode */
      .footer.is-standalone::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        /* Solid base bar that visually replaces the transparent area near the iOS home indicator */
        height: 1.6rem;
        background: #000;
      }

      .footer.is-standalone .footer-links {
        /* Horizontal nudge + slight downward shift to center vertically in the bar */
        transform: translate(6px, 3px);
      }

      /* When logged in on iPhone in standalone mode: shift left a bit, keep vertical shift */
      .footer.is-standalone .footer-links.footer-links-logged-in {
        transform: translate(-0px, 3px);
      }
    }
  }
  
  .footer-link {
    font-size: 0.9rem;
    text-decoration: none;
    text-transform: uppercase;
    margin-right: 0.8rem;
  }
  
  .footer-separator-icon {
    margin-left: 0.4rem;
    margin-right: 1.2rem;
  }
  
  .footer-separator-icon.small {
    width: 14px;
    height: 14px;
  }
  
  .footer-separator-icon.large {
    width: 20px;
    height: 20px;
  }
}

/* Force mobile layout even in landscape orientation */
@media(max-width: 768px) and (orientation: landscape) {
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    z-index: 10000;
    align-items: center;
    /* Default padding for landscape (smaller, no black border) */
    padding: 0.8rem 1.3rem 1.0rem;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(10px);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  /* iPhone with home indicator in landscape: show black border */
  @supports (-webkit-touch-callout: none) {
    @supports (padding-bottom: env(safe-area-inset-bottom)) {
      .footer {
        padding: 0.8rem 1.3rem 2.8rem;
      }

      .footer::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 1.6rem;
        background: #000;
      }
    }
  }
}
</style>
